var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "bg-picker",
    },
    [
      !_vm.isEditMode
        ? _c(
            "button",
            {
              staticClass: "bg-picker-options__trigger",
              class: { "is-open": _vm.isOpen },
              attrs: {
                "aria-expanded": _vm.isOpen.toString(),
                "aria-haspopup": "true",
              },
              on: { click: _vm.toggle },
            },
            [_c("i", { staticClass: "bi bi-three-dots-vertical" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditMode
        ? _c("div", { staticClass: "display-builder-edit-actions" }, [
            _c(
              "button",
              {
                staticClass:
                  "dbh-btn dbh-btn--outline display-builder-edit-actions__cancel text-sm",
                attrs: { type: "button" },
                on: { click: _vm.cancelEditLayout },
              },
              [_c("i", { staticClass: "bi bi-x-lg" }), _vm._v(" Cancel\n    ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "display-builder-layout-save-menu" }, [
              _c("div", { staticClass: "dbh-split-btn" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "dbh-btn dbh-btn--primary dbh-split-btn__main display-builder-edit-actions__done text-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.finishEditLayout },
                  },
                  [
                    _c("i", { staticClass: "bi bi-floppy" }),
                    _vm._v(" Save Layout\n        "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "dbh-btn dbh-btn--primary dbh-split-btn__caret display-builder-edit-actions__done text-sm",
                    attrs: {
                      type: "button",
                      "aria-label": "More layout save options",
                      "aria-expanded": _vm.isLayoutSaveMenuOpen.toString(),
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleLayoutSaveMenu.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-down" })]
                ),
              ]),
              _vm._v(" "),
              _vm.isLayoutSaveMenuOpen
                ? _c(
                    "div",
                    { staticClass: "display-builder-layout-save-menu__panel" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "display-builder-layout-save-menu__item text-sm",
                          attrs: { type: "button" },
                          on: { click: _vm.saveAsNewLayout },
                        },
                        [
                          _c("i", { staticClass: "bi bi-plus-lg" }),
                          _vm._v("\n          Save as new Layout...\n        "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "bg-picker__panel-options" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "bg-picker__panel-options",
                style: _vm.panelPositionStyle,
                attrs: { role: "menu" },
              },
              [
                _c("div", { staticClass: "section-header" }, [
                  _vm._v("\n        Layout\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: { click: _vm.newLayout },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-plus h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M5 12h14" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M12 5v14" } }),
                      ]
                    ),
                    _vm._v("\n        New Layout\n      "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: { click: _vm.editLayout },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-pencil h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "m15 5 4 4" } }),
                      ]
                    ),
                    _vm._v("\n        Edit Layout\n      "),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "separator w-100" }),
                _vm._v(" "),
                _c("div", { staticClass: "section-header" }, [
                  _vm._v("\n        Save\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: { click: _vm.saveAsNewLayout },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-plus h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M5 12h14" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M12 5v14" } }),
                      ]
                    ),
                    _vm._v("\n        Save as new layout...\n      "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: { click: _vm.updateBaseLayout },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-save h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M7 3v4a1 1 0 0 0 1 1h7" } }),
                      ]
                    ),
                    _vm._v("\n        Update base layout\n      "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: {
                      disabled: !_vm.canManageDefaults,
                      role: "menuitem",
                    },
                    on: { click: _vm.saveAsDefault },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-save h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M7 3v4a1 1 0 0 0 1 1h7" } }),
                      ]
                    ),
                    _vm._v("\n        Set as startup layout\n      "),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "separator w-100" }),
                _vm._v(" "),
                _c("div", { staticClass: "section-header" }, [
                  _vm._v("\n        File\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: { click: _vm.exportLayout },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-download h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                          },
                        }),
                        _vm._v(" "),
                        _c("polyline", {
                          attrs: { points: "7 10 12 15 17 10" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", x2: "12", y1: "15", y2: "3" },
                        }),
                      ]
                    ),
                    _vm._v("\n        Export layout...\n      "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.displayBuilderImportInput.click()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-upload h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                          },
                        }),
                        _vm._v(" "),
                        _c("polyline", { attrs: { points: "17 8 12 3 7 8" } }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "12", x2: "12", y1: "3", y2: "15" },
                        }),
                      ]
                    ),
                    _vm._v("\n        Import layout...\n      "),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  ref: "displayBuilderImportInput",
                  staticClass: "d-none",
                  attrs: { type: "file", accept: "application/json,.json" },
                  on: { change: _vm.importDisplayBuilderLayout },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "separator w-100" }),
                _vm._v(" "),
                _c("div", { staticClass: "section-header" }, [
                  _vm._v("\n        Share\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem", disabled: _vm.isCopyingLink },
                    on: { click: _vm.copyProofLink },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-link2 h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M9 17H7A5 5 0 0 1 7 7h2" } }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { d: "M15 7h2a5 5 0 1 1 0 10h-2" },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "8", x2: "16", y1: "12", y2: "12" },
                        }),
                      ]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isCopyingLink ? "Creating link..." : "Copy link"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { disabled: true, role: "menuitem" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-mail h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "16",
                            x: "2",
                            y: "4",
                            rx: "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
                          },
                        }),
                      ]
                    ),
                    _vm._v("\n        Email...\n      "),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "separator w-100" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "bg-picker__option",
                    attrs: { role: "menuitem" },
                    on: { click: _vm.resetLayout },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-rotate-ccw h-4 w-4 mr-2",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M3 3v5h5" } }),
                      ]
                    ),
                    _vm._v("\n        Reset canvas\n      "),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }